import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
  FaShoppingBag,
  FaCheck,
  FaStar,
  FaTruck,
  FaGuitar,
  FaMusic,
  FaArrowRight,
  FaFireAlt,
  FaBullhorn,
  FaSearch,
} from "react-icons/fa";

import {
  Hero,
  HeroContent,
  HeroButtons,
  BtnPrimary,
  BtnSecondary,
  Section,
  Container,
  SectionTitle,
  BandsGrid,
  BandCard,
  CategoriesGrid,
  CategoryCard,
  FeaturesGrid,
  FeatureCard,
  FeatureIcon,
  NewsletterWrapper,
  NewsletterForm,
  PrivacyNote,
  ProductShowcase,
  SectionSubtitle,
  LatestNews,
  NewsCard,
  NewsGrid,
  LogoContainer,
  NewsletterButton,
  EmptyBox,
} from "./HomePage.styles";

import MainContainer from "../../../components/utils/MainContainer";
import ProductCard from "../../../components/utils/ProductCard";
import Particles from "../../../components/utils/Particles";

import { useNavigate } from "react-router-dom";

import { ReactComponent as Logo } from "../../../assets/icons/logoMrc.svg";
import {
  selectFeaturedCategories,
  selectFeaturedProducts,
} from "../../../store/slices/products/slice";
import { selectFeaturedBands } from "../../../store/slices/bands/slice";
import { selectFeaturedNews } from "../../../store/slices/news/slice";
import { useDispatch, useSelector } from "react-redux";
import {
  getFeaturedCategories,
  getFeaturedProducts,
} from "../../../store/slices/products/asyncThunks";
import { getFeaturedBands } from "../../../store/slices/bands/asyncThunks";
import { getFeaturedNews } from "../../../store/slices/news/asyncThunks";
import { categoryMapping } from "../../../utils/utils";
import { createNewsletter } from "../../../store/slices/newsletters/asyncThunks";
import { selectNewsletterLoading } from "../../../store/slices/newsletters/slice";
import { toast } from "../../../components/modern-ui/sonner";
import NewsletterPreferencesModal from "../../../components/utils/NewsletterPreferencesModal";
import MailChecker from "mailchecker";

const HomePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: featuredCategories, loading: featuredCategoriesLoading } =
    useSelector(selectFeaturedCategories);
  const { data: featuredProducts, loading: featuredProductsLoading } =
    useSelector(selectFeaturedProducts);
  const { data: featuredBands, loading: featuredBandsLoading } =
    useSelector(selectFeaturedBands);
  const { data: featuredNews, loading: featuredNewsLoading } =
    useSelector(selectFeaturedNews);

  const newsletterLoading = useSelector(selectNewsletterLoading);
  const [newsletterEmail, setNewsletterEmail] = useState("");

  useEffect(() => {
    dispatch(getFeaturedProducts())
      .unwrap()
      .then(() => {})
      .catch((err) => console.log(err.message));

    dispatch(getFeaturedCategories())
      .unwrap()
      .then(() => {})
      .catch((err) => console.log(err.message));

    dispatch(getFeaturedBands())
      .unwrap()
      .then(() => {})
      .catch((err) => console.log(err.message));

    dispatch(getFeaturedNews())
      .unwrap()
      .then(() => {})
      .catch((err) => console.log(err.message));
  }, []);

  const [showPreferencesModal, setShowPreferencesModal] = useState(false);
  const [modalError, setModalError] = useState(null);

  const handleNewsletterClick = (e) => {
    e.preventDefault();

    // Validate email first
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(newsletterEmail)) {
      toast.error("Molimo Vas unesite važeću email adresu");
      return;
    }
    if (!MailChecker.isValid(newsletterEmail)) {
      toast.error("Molimo Vas unesite važeću email adresu");
      return;
    }

    // Open preferences modal
    setShowPreferencesModal(true);
    setModalError(null);
  };

  const handleSubscribeWithPreferences = ({ email, preferences }) => {
    // Create newsletter with preferences
    dispatch(
      createNewsletter({
        email: email,
        preferences: preferences,
      })
    )
      .unwrap()
      .then(() => {
        setNewsletterEmail("");
        setShowPreferencesModal(false);
        toast.success("Uspešno ste se pretplatili na newsletter!");
      })
      .catch((err) => {
        setModalError(err.message || "Greška prilikom pretplate");
      });
  };

  const closeModal = () => {
    setShowPreferencesModal(false);
    setModalError(null);
  };

  return (
    <>
      <MainContainer>
        {/* HERO */}
        <Hero id="home">
          <Particles />
          <HeroContent>
            <LogoContainer>
              <Logo
                style={{
                  filter: "drop-shadow(3px 3px 6px rgba(0, 0, 0, 0.5))",
                }}
              />
            </LogoContainer>
            <motion.h1
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              Originalni Merchandise
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              Zvanični proizvodi omiljenih bendova, <br />
              pokaži svetu koju muziku voliš
            </motion.p>

            {/* <HeroStats>
            <div className="stat">
              <FaUsers />
              <span>15+ Bendova</span>
            </div>
            <div className="stat">
              <FaShoppingBag />
              <span>200+ Proizvoda</span>
            </div>
            <div className="stat">
              <FaHeart />
              <span>5000+ Kupaca</span>
            </div>
          </HeroStats> */}

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              <HeroButtons>
                <BtnPrimary
                  onClick={() => {
                    navigate("/prodavnica");
                    setTimeout(() => {
                      window.scrollTo(0, 0);
                    }, 300);
                  }}
                >
                  <FaShoppingBag />
                  Pregledaj Kolekciju
                </BtnPrimary>
                <BtnSecondary
                  onClick={() => {
                    navigate("/bendovi");
                    setTimeout(() => {
                      window.scrollTo(0, 0);
                    }, 300);
                  }}
                >
                  <FaMusic />
                  Naši Bendovi
                </BtnSecondary>
              </HeroButtons>
            </motion.div>
          </HeroContent>
        </Hero>

        {/* FEATURED PRODUCTS */}
        <Section $bg="#1a1a1a" id="featured">
          <Particles />
          <Container>
            <SectionTitle>
              <FaFireAlt />
              Istaknuti Proizvodi
            </SectionTitle>
            <SectionSubtitle>
              Najpopularniji i najnoviji proizvodi naših partnera
            </SectionSubtitle>

            {featuredProductsLoading ? (
              <EmptyBox
                style={{
                  color: "#ff6b35",
                }}
              >
                <l-line-spinner size="20" stroke="2" speed="1" color="#fff" />
                Učitavanje proizvoda...
              </EmptyBox>
            ) : featuredProducts.length > 0 ? (
              <ProductShowcase>
                {featuredProducts.map((product, index) => {
                  const safeProduct = {
                    ...product,
                    category: product?.category || { name: "N/A" },
                    band: product?.band?.name || product?.band || "N/A",
                    name: product?.name || "Nepoznat proizvod",
                    price: product?.price || 0,
                    discountPrice: product?.salePrice || null,
                    images: product?.images || [],
                  };

                  return (
                    <ProductCard
                      key={product.id || index}
                      product={safeProduct}
                      hideAddToCart
                    />
                  );
                })}
              </ProductShowcase>
            ) : (
              <EmptyBox>Trenutno nema istaknutih proizvoda.</EmptyBox>
            )}
          </Container>
        </Section>

        {/* FEATURED BANDS */}
        <Section $bg="#2c2c2c" id="bands">
          <Particles />
          <Container>
            <SectionTitle>
              <FaGuitar />
              Naši Partneri
            </SectionTitle>
            <SectionSubtitle>
              Bendovi čiji originalni merchandise možete pronaći kod nas
            </SectionSubtitle>

            {featuredBandsLoading ? (
              <EmptyBox
                style={{
                  color: "#ff6b35",
                }}
              >
                <l-line-spinner size="20" stroke="2" speed="1" color="#fff" />
                Učitavanje bendova...
              </EmptyBox>
            ) : featuredBands.length > 0 ? (
              <BandsGrid>
                {featuredBands.map((band, index) => {
                  const colors = [
                    { color: "#e74c3c", shadow: "#e74c3c40" },
                    { color: "#3498db", shadow: "#3498db40" },
                    { color: "#9b59b6", shadow: "#9b59b640" },
                    { color: "#e67e22", shadow: "#e67e2240" },
                    { color: "#27ae60", shadow: "#27ae6040" },
                    { color: "#16a085", shadow: "#16a08540" },
                    { color: "#f39c12", shadow: "#f39c1240" },
                  ];
                  const colorIndex = index % colors.length;
                  const bandColors = colors[colorIndex];

                  return (
                    <BandCard
                      onClick={() => {
                        navigate(`/prodavnica?bend=${band.id}`);
                        setTimeout(() => {
                          window.scrollTo(0, 0);
                        }, 300);
                      }}
                      key={band.id || band.name}
                      style={{
                        "--accent-color": bandColors.color,
                        "--accent-shadow": bandColors.shadow,
                      }}
                    >
                      {(() => {
                        // Find main image from bandImages array
                        const mainImage = band.bandImages?.find(
                          (img) => img.isMain
                        );
                        const imageUrl = mainImage?.url || band.mainImage;

                        if (imageUrl) {
                          return (
                            <img
                              src={imageUrl}
                              alt={band.name}
                              className="band-logo"
                              onError={(e) => {
                                // Fallback to text logo if image fails to load
                                e.target.style.display = "none";
                                e.target.nextElementSibling.style.display =
                                  "flex";
                              }}
                            />
                          );
                        } else {
                          return (
                            <div className="band-logo">
                              {band.name?.substring(0, 2) || "??"}
                            </div>
                          );
                        }
                      })()}
                      <h3>{band.name || "Nepoznat bend"}</h3>
                      <p className="genre">{band.genre || "Muzika"}</p>
                      <p className="products">
                        {band.numOfProducts || 0}+ proizvoda
                      </p>
                      <div className="cta">
                        <FaArrowRight />
                        Pogledaj proizvode
                      </div>
                    </BandCard>
                  );
                })}
              </BandsGrid>
            ) : (
              <EmptyBox>Trenutno nema istaknutih bendova.</EmptyBox>
            )}
          </Container>
        </Section>

        {/* PRODUCT CATEGORIES */}
        <Section $bg="#1a1a1a" id="categories">
          <Particles />
          <Container>
            <SectionTitle>
              <FaShoppingBag />
              Kategorije Proizvoda
            </SectionTitle>
            <SectionSubtitle>Pronađite baš ono što tražite</SectionSubtitle>

            {featuredCategoriesLoading ? (
              <EmptyBox
                style={{
                  color: "#ff6b35",
                }}
              >
                <l-line-spinner size="20" stroke="2" speed="1" color="#fff" />
                Učitavanje kategorija...
              </EmptyBox>
            ) : featuredCategories.length > 0 ? (
              <CategoriesGrid>
                {featuredCategories.map((category, index) => {
                  const mapping = categoryMapping[category.name.toLowerCase()];

                  const Icon = mapping ? mapping.icon : FaShoppingBag;
                  const displayName = mapping ? mapping.name : category.name;

                  const colors = [
                    { color: "#e74c3c", shadow: "#e74c3c40" },
                    { color: "#3498db", shadow: "#3498db40" },
                    { color: "#9b59b6", shadow: "#9b59b640" },
                    { color: "#e67e22", shadow: "#e67e2240" },
                    { color: "#27ae60", shadow: "#27ae6040" },
                    { color: "#16a085", shadow: "#16a08540" },
                    { color: "#f39c12", shadow: "#f39c1240" },
                  ];
                  const colorIndex = index % colors.length;
                  const categoryColors = colors[colorIndex];

                  return (
                    <CategoryCard
                      key={index + "-"}
                      onClick={() => {
                        navigate(`/prodavnica?kategorija=${category.id}`);
                        setTimeout(() => {
                          window.scrollTo(0, 0);
                        }, 300);
                      }}
                      style={{
                        "--category-color": categoryColors.color,
                        "--category-shadow": categoryColors.shadow,
                      }}
                    >
                      <Icon
                        color={categoryColors.color}
                        size={category.name === "Duks" ? 53 : 48}
                        style={{
                          marginBottom: category.name === "Duks" ? -2.5 : 0,
                        }}
                      />
                      <h3>{displayName}</h3>
                      <p>{category.description}</p>
                      {category.numOfProducts === 1 ? (
                        <div className="count">1 proizvod</div>
                      ) : category.numOfProducts > 10 ? (
                        <div className="count">10+ proizvoda</div>
                      ) : (
                        <div className="count">
                          {category.numOfProducts} proizvoda
                        </div>
                      )}

                      <div className="category-cta">
                        Istraži
                        <FaArrowRight />
                      </div>
                    </CategoryCard>
                  );
                })}
              </CategoriesGrid>
            ) : (
              <EmptyBox>Kategorije se učitavaju ili nisu dostupne.</EmptyBox>
            )}
          </Container>
        </Section>

        {/* LATEST NEWS */}
        <LatestNews>
          <Container>
            <SectionTitle>
              <FaBullhorn />
              Poslednje Novosti
            </SectionTitle>

            {featuredNewsLoading ? (
              <EmptyBox
                style={{
                  color: "#ff6b35",
                }}
              >
                <l-line-spinner size="20" stroke="2" speed="1" color="#fff" />
                Učitavanje novosti...
              </EmptyBox>
            ) : featuredNews.length > 0 ? (
              <NewsGrid>
                {featuredNews.map((news, index) => (
                  <NewsCard
                    key={index + "+"}
                    onClick={() => {
                      navigate(`/novost/${news.id}`);
                      setTimeout(() => {
                        window.scrollTo(0, 0);
                      }, 300);
                    }}
                  >
                    <div className="news-date">
                      {news.createdAt
                        ? new Date(news.createdAt).toLocaleDateString(
                            "sr-Latn-RS"
                          )
                        : "Nedavno"}
                    </div>
                    <h3>{news.title || "Bez naslova"}</h3>
                    <p>{news.text || "Nema opisa"}</p>
                    <div className="read-more">
                      Čitaj više <FaArrowRight />
                    </div>
                  </NewsCard>
                ))}
              </NewsGrid>
            ) : (
              <EmptyBox>Trenutno nema dostupnih novosti.</EmptyBox>
            )}
          </Container>
        </LatestNews>

        {/* FEATURES */}
        <Section $bg="#2c2c2c">
          <Particles />
          <Container>
            <SectionTitle>
              <FaSearch />
              Zašto МРЧ?
            </SectionTitle>

            <FeaturesGrid>
              {[
                {
                  icon: FaCheck,
                  title: "100% Originalni Proizvodi",
                  desc: "Svi proizvodi su zvanično licencirani",
                },
                {
                  icon: FaStar,
                  title: "Premium Kvalitet",
                  desc: "Visokokvalitetna štampa i materijali",
                },
                {
                  icon: FaTruck,
                  title: "Brza Dostava",
                  desc: "Dostavljamo kurirskom sluzbom PostExpres na teritoriji cele Srbije",
                },
                {
                  icon: FaGuitar,
                  title: "Podrška Bendovima",
                  desc: "Kupovinom na ovom sajtu direktno pomazete radu bendova",
                },
              ].map((feature, index) => (
                <FeatureCard
                  key={feature.title}
                  as={motion.div}
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                >
                  <FeatureIcon>
                    <feature.icon />
                  </FeatureIcon>
                  <h3>{feature.title}</h3>
                  <p>{feature.desc}</p>
                </FeatureCard>
              ))}
            </FeaturesGrid>
          </Container>
        </Section>

        {/* NEWSLETTER */}
        <NewsletterWrapper>
          <Container>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <h2>Ostani u Toku sa Novostima</h2>
              <p>
                Primi obaveštenja o novim proizvodima, akcijama i koncertima
              </p>
              <NewsletterForm>
                <input
                  type="email"
                  placeholder="Unesi svoj email"
                  required
                  value={newsletterEmail}
                  onChange={(e) => setNewsletterEmail(e.target.value)}
                />
                <NewsletterButton
                  disabled={newsletterLoading || newsletterEmail === ""}
                  onClick={handleNewsletterClick}
                >
                  Pretplati se
                  {newsletterLoading ? (
                    <l-line-spinner
                      size="18"
                      stroke="1.5"
                      speed="1"
                      color="#fff"
                    />
                  ) : (
                    <FaArrowRight />
                  )}
                </NewsletterButton>
              </NewsletterForm>
              <PrivacyNote>
                Poštujemo tvoju privatnost. Bez spam-a, obećavamo!
              </PrivacyNote>
            </motion.div>
          </Container>
        </NewsletterWrapper>
      </MainContainer>
      <NewsletterPreferencesModal
        isOpen={showPreferencesModal}
        onClose={closeModal}
        email={newsletterEmail}
        onSubscribe={handleSubscribeWithPreferences}
        loading={newsletterLoading}
        error={modalError}
      />
    </>
  );
};

export default HomePage;
